import { ReprocessamentoService } from './../services/reprocessamento/reprocessamento.service';
import { EmpresaService } from './../services/empresa/empresa.service';
import { SnotifyService } from 'ng-snotify';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: 'app-reprocessamento',
  templateUrl: './reprocessamento.component.html',
  styleUrls: ['./reprocessamento.component.scss']
})
export class ReprocessamentoComponent implements OnInit {

  public loading = false;

  public empresas: Array<any> = [];

  public status: Array<any> = [
    { id:3, descricao: "3 | ERRO AO LER ARQUIVO",},
    { id:5, descricao: "5 | NÃO EXISTE MAPEAMENTO PARA ESTE LAYOUT DE PDF",},
    { id:6, descricao: "6 | GERADO COM ERRO",},
    { id:7, descricao: "7 | ERRO DESCONHECIDO",}
  ];

  public filter: FormGroup = this.fb.group({
    empresa: new FormControl('', []),
    status: new FormControl('', []),
    recebido_em_ini: new FormControl('', []),
    recebido_em_fim: new FormControl('', [])
  });

  public dropdownSettingsEmpresas = {
    singleSelection: false,
    idField: 'descricao',
    textField: 'descricao',
    itemsShowLimit: 8,
    selectAllText: 'Marcar todas',
    unSelectAllText: 'Desmarcar todas',
    allowSearchFilter: true
  };

  public dropdownSettingsStatus = {
    singleSelection: true,
    idField: 'id',
    textField: 'descricao',
    itemsShowLimit: 1,
    allowSearchFilter: false
  };

  constructor(
      private _notify: SnotifyService,
      private empresaService: EmpresaService,
      private reprocessamentoService: ReprocessamentoService,
      private fb: FormBuilder
  )  { 
  }

  ngOnInit() { 
    this._listarEmpresas();
  }

  public loadData() {
    this.reprocessamentoService.reprocessar(this.getFilters()).subscribe(
        ({data}:any) => {
          this.loading = false

          if(Object.keys(data).length > 0) {
            Object.entries(data).forEach(([key, value]) => {
              if(value) {
                this._notify.success("Reprocessamento da empresa " + key + " iniciado com sucesso.", "", {timeout: 5000});
              } else {
                this._notify.error("Falha ao iniciar o Reprocessamento da empresa " + key + ".", "", {timeout: 5000});
              }
            });

            Object.keys(this.filter.controls).forEach(key => {
              this.filter.controls[key].setValue(null);
            });
          } else {
            this._notify.warning("Selecione ao menos uma Empresa para reprocessar.");
          }
        },
        error => {
            this.loading = false
            this._notify.error("Ocorreu um erro ao iniciar o reprocessamento.")
        }
    )
  }

  public toFilter() {
    this.loading = true;
    this.loadData();
  }

  public getFilters() {
    const filter = {};

    Object.keys(this.filter.controls).forEach((_filter) => {
      filter[_filter] = this.filter.controls[_filter].value;
    });

    if (filter['empresa']) {
      filter['empresa'] = filter['empresa'].map(empresa => {
          return empresa.descricao;
      });
    }

    return filter;
  }

  private _listarEmpresas(): void  {
    this.empresaService.listar(null, '', 'todos')
    .subscribe(
        ({data}) => {

          let flags = [], output = [];
          for( let i=0; i< data.empresas.length; i++) {
            if( flags[data.empresas[i].nome]) continue;
            flags[data.empresas[i].nome] = true;
            if(data.empresas[i].nome != null) {
              output.push({descricao: data.empresas[i].nome});
            }
          }

          this.empresas = output;
        },
        error => {
          this._notify.warning('Ocorreu um erro ao carregar empresas');
        }
    );
  }

}
